export const CEREBRO_LESSON_PLAN_PROMPT_NAME = 'lpCerebroTeachingGuide';
export const CEREBRO_LESSON_PLAN_MAX_LEARNING_COMP = 3;
